/**
 * 图片对比滑块组件
 * 支持鼠标拖动和触摸操作
 */

class ImageComparison {
  constructor(element) {
    this.container = element;
    this.wrapper = element.querySelector('.image-comparison-container');
    this.beforeImage = element.querySelector('[data-before-image]');
    this.slider = element.querySelector('[data-slider]');
    
    if (!this.wrapper || !this.beforeImage || !this.slider) {
      console.warn('图片对比组件：缺少必要元素');
      return;
    }

    this.isDragging = false;
    this.currentPosition = 50; // 初始位置50%
    
    this.init();
  }

  init() {
    // 绑定事件
    this.bindEvents();
    
    // 设置初始位置
    this.updatePosition(this.currentPosition);
  }

  bindEvents() {
    // 鼠标事件
    this.slider.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.onDrag.bind(this));
    document.addEventListener('mouseup', this.stopDrag.bind(this));

    // 触摸事件
    this.slider.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });
    document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
    document.addEventListener('touchend', this.stopDrag.bind(this));

    // 点击容器直接跳转到该位置
    this.wrapper.addEventListener('click', this.onClickContainer.bind(this));

    // 防止图片拖动
    const images = this.wrapper.querySelectorAll('img');
    images.forEach(img => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  startDrag(e) {
    this.isDragging = true;
    this.wrapper.classList.add('is-dragging');
    e.preventDefault();
  }

  stopDrag() {
    if (this.isDragging) {
      this.isDragging = false;
      this.wrapper.classList.remove('is-dragging');
    }
  }

  onDrag(e) {
    if (!this.isDragging) return;

    e.preventDefault();
    
    const position = this.getPositionFromEvent(e);
    this.updatePosition(position);
  }

  onClickContainer(e) {
    // 如果点击的是滑块本身，不处理
    if (e.target.closest('[data-slider]')) return;
    
    const position = this.getPositionFromEvent(e);
    this.updatePosition(position);
  }

  getPositionFromEvent(e) {
    const rect = this.wrapper.getBoundingClientRect();
    let clientX;

    // 处理触摸事件和鼠标事件
    if (e.type.includes('touch')) {
      clientX = e.touches?.[0]?.clientX || e.changedTouches?.[0]?.clientX;
    } else {
      clientX = e.clientX;
    }

    // 计算相对位置（百分比）
    let position = ((clientX - rect.left) / rect.width) * 100;
    
    // 限制范围在 0-100 之间
    position = Math.max(0, Math.min(100, position));
    
    return position;
  }

  updatePosition(position) {
    this.currentPosition = position;
    
    // 更新before图片容器宽度
    this.beforeImage.style.width = `${position}%`;
    
    // 更新滑块位置
    this.slider.style.left = `${position}%`;
  }
}

// 初始化所有图片对比组件
function initImageComparisons() {
  const comparisons = document.querySelectorAll('[data-image-comparison]');
  comparisons.forEach(element => {
    new ImageComparison(element);
  });
}

// 页面加载完成后初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageComparisons);
} else {
  initImageComparisons();
}

// 支持 Shopify 主题编辑器实时预览
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initImageComparisons, 100);
  });
}

